import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import CheckCircleSharpIcon from '@mui/icons-material/CheckCircleSharp';
import { Button } from '@mui/material';

const UploadButton = ({
  buttonState,
  buttonType,
  handleFileUpload,
  allowReplace = false,
  children,
}) => {
  const bcButton = buttonState ? (
    <span className='inline-flex items-center gap-2'>
      <CheckCircleSharpIcon
        filled='true'
        color='success'
        id={`complete-${buttonType}`}
      />
      {allowReplace && (
        <label
          className='cursor-pointer text-sm text-blue-700 underline'
          data-cy={`replace-${buttonType}`}
        >
          Replace
          <input
            hidden
            type='file'
            id={`input-${buttonType}`}
            onChange={e => handleFileUpload(e, buttonType)}
          />
        </label>
      )}
    </span>
  ) : (
    <Button variant='contained' component='label' id={`button-${buttonType}`}>
      Upload
      <input
        hidden
        type='file'
        id={`input-${buttonType}`}
        onChange={e => handleFileUpload(e, buttonType)}
      />
    </Button>
  );

  return (
    <Grid container spacing={2}>
      <Grid xs={8}>{children}</Grid>
      <Grid xs={4} className='center' id={`grid-${buttonType}`}>
        {bcButton}
      </Grid>
    </Grid>
  );
};

export default UploadButton;
